module.exports = __webpack_public_path__ + "open-sans-latin-300italic.955e54c0e4249aa15b96.eot";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-300italic.eot
// module id = ../../../../typeface-open-sans/files/open-sans-latin-300italic.eot
// module chunks = 1 3